import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useMemo } from "react";
import apiRequest from "../../functions/api";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { TextField, Button, Paper, Toolbar } from "@mui/material";
import { DialogContent, TableContainer, Grid, Box, Table, TableHead, TableBody, TableRow, TableCell, Hidden, MenuItem, Card } from "@mui/material";
import { useMessage } from "../../context/message-context";
import { FullPageSpinner, SearchTextField } from "../lib";
import openFile from "../shared/functions/download";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import GridOnIcon from "@mui/icons-material/GridOn";
import TimeAccount from "../TimeAccountComponent";
import Modulgruppenfilter from "../Modulgruppenfilter/Modulgruppenfilter";
function EmployeeStatistics(props) {
  const { t } = useTranslation();
  const { client, accessToken, admin } = props;
  const [type, setType] = useState("URLAUB");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [showModal, setShowModal] = useState(false);
  const [gleitzeitkonten, setGleitzeitkonten] = useState([]);
  const [urlaubskonten, setUrlaubskonten] = useState([]);
  const [gleitzeitkonto, setGleitzeitkonto] = useState("0000");
  const [urlaubskonto, setUrlaubskonto] = useState("0000");
  const { showErrorMessage, hideMessage } = useMessage();
  const [openUrlaub, setOpenUrlaub] = useState(0);
  const [openGleitzeit, setOpenGleitzeit] = useState(0);
  const [openKrank, setOpenKrank] = useState(0);
  const [currentObject, setCurrentObject] = useState();
  const [currentPnr, setCurrentPnr] = useState("");
  const [currentName, setCurrentName] = useState("");
  const [ZJ, setZJ] = useState("");
  const [ZJName, setZJName] = useState("");
  const [kkst, setKkst] = useState([]);
  const [laks, setLaks] = useState([]);
  const [abrk, setAbrk] = useState(0);
  const [kst, setKst] = useState(0);
  const [gruppen, setGruppen] = useState([]);
  const [magruppen, setMagruppen] = useState([]);
  const [statistics, setStatistics] = useState([{ key: "URLAUB", name: "Urlaubsstatistik" }]);
  const [gruppe, setGruppe] = useState("A");
  const [untergeben, setUntergeben] = useState("D");
  const [filteraktiv, setFilteraktiv] = useState("");

  useEffect(() => {
    setIsLoading(true);

    if (admin) {
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      const payload = {
        mandant: client,
        program: admin ? "PMAST1" : "",
        statement: "HOLE_AN",
        type: type,
        year: year,
      };
      apiRequest("POST", "daten", payload, headers, dataCbAdmin, errorCb);
    } else {
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      const payload = {
        mandant: client,
        program: admin ? "PMAST1" : "PMAST0",
        statement: "HOLE_OIDS",
        untergeben: untergeben,
        type: type,
        year: year,
      };
      apiRequest("POST", "daten", payload, headers, dataCbModul, errorCb);
    }

    // eslint-disable-next-line
  }, [untergeben]);

  const errorCb = () => {
    setIsLoading(false);
  };

  const dataCb = (response) => {
    setShowModal(false);
    if (response.status === 200) {
      setData(response.data.user);
      setKkst(response.data.kkst);
      setLaks(response.data.laks);
      if (response.data.gruppen) {
        setGruppen(response.data.gruppen);
      }
      if (response.data.statistiken) {
        setStatistics(response.data.statistiken);
      }
      if (response.data.magruppen) {
        setMagruppen(response.data.magruppen);
      }
      if (response.data.filter) {
        setFilteraktiv(response.data.filter);
      }
      if (response.data.glzkonten) {
        setGleitzeitkonten(response.data.glzkonten);
      }
      if (response.data.urlaubskonten) {
        setUrlaubskonten(response.data.urlaubskonten);
      }
      if (response.data.starturl) {
        setUrlaubskonto(response.data.starturl);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const dataCbAdmin = (response) => {
    getDaten(response.data.arbeitnehmer, response.data.year);
  };

  const dataCbModul = (response) => {
    if (response.data.unterstellte) setUntergeben(response.data.unterstellte)
    getDaten(response.data.arbeitnehmer, response.data.year);
  };

  function mergeArrays(array1, array2, compare) {
    const tmparray1 = [...array1];
    const tmparray2 = [...array2];
    tmparray2.forEach((item) => {
      if (tmparray1.some((e) => e[compare] === item[compare]) === false) tmparray1.push(item);
    });
    return tmparray1;
  }

  async function getDaten(arbeitnehmer, tmpyear) {

    const values = await Promise.all(
      arbeitnehmer.map(async (item) => {
        return maListeLaden(item, tmpyear);
      }),
    );

    var laks_array = [];
    var user_array = [];
    var kkst_array = [];
    var statistiken_array = [];
    var urlaubskonten_array = [];
    var glzkonten_array = [];
    var gruppen_array = [];
    var magruppen_array = [];
    var filteraktiv_var = "";
    var starturl_var = "";

    values.forEach((item, index) => {
      if (index === 0) {
        if (item.data.laks) laks_array = [...item.data.laks];
        if (item.data.kkst) kkst_array = [...item.data.kkst];
        if (item.data.user) user_array = [...item.data.user];
        if (item.data.statistiken) statistiken_array = [...item.data.statistiken];
        if (item.data.urlaubskonten) urlaubskonten_array = [...item.data.urlaubskonten];
        if (item.data.glzkonten) glzkonten_array = [...item.data.glzkonten];
        if (item.data.gruppen) gruppen_array = [...item.data.gruppen];
        if (item.data.magruppen) magruppen_array = [...item.data.magruppen];
        starturl_var = item.data.starturl;
        filteraktiv_var = item.data.filter;
      } else {
        if (item.data.starturl) starturl_var = item.data.starturl;
        if (item.data.laks) laks_array = [...mergeArrays(laks_array, item.data.laks, "key")];
        if (item.data.kkst) kkst_array = [...mergeArrays(kkst_array, item.data.kkst, "key")];
        if (item.data.user) user_array = [...mergeArrays(user_array, item.data.user, "key")];
        if (item.data.statistiken) statistiken_array = [...mergeArrays(statistiken_array, item.data.statistiken, "key")];
        if (item.data.urlaubskonten) urlaubskonten_array = [...mergeArrays(urlaubskonten_array, item.data.urlaubskonten, "key")];
        if (item.data.glzkonten) glzkonten_array = [...mergeArrays(glzkonten_array, item.data.glzkonten, "key")];
        if (item.data.gruppen) gruppen_array = [...mergeArrays(gruppen_array, item.data.gruppen, "key")];
        if (item.data.magruppen) magruppen_array = [...mergeArrays(magruppen_array, item.data.magruppen, "key")];
      }
    });

    setData(user_array);
    setKkst(kkst_array);
    setLaks(laks_array);
    if (gruppen_array) {
      setGruppen(gruppen_array);
    }
    if (statistiken_array) {
      setStatistics(statistiken_array);
    }
    if (magruppen_array) {
      setMagruppen(magruppen_array);
    }
    if (glzkonten_array) {
      setGleitzeitkonten(glzkonten_array);
    }
    if (urlaubskonten_array) {
      setUrlaubskonten(urlaubskonten_array);
    }
    if (starturl_var) {
      setUrlaubskonto(starturl_var);
    }
    if (filteraktiv_var) {
      setFilteraktiv(filteraktiv_var);
    }

    setShowModal(false);
    setIsLoading(false);
    hideMessage();

    return values;
  }

  const maListeLaden = async (arbeitnehmer, tmpyear) => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: admin ? "PMAST1" : "PMAST0",
      statement: "MA_LADEN",
      maliste: arbeitnehmer.liste,
      type: type,
      year: tmpyear,
    };
    return await apiDataRequest(payload, headers).then({}).catch(errorCb);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const handleYearChange = (e) => {
    const { value } = e.target;
    setShowModal(true);

    if (admin) {
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      const payload = {
        mandant: client,
        program: admin ? "PMAST1" : "",
        statement: "HOLE_AN",
        type: type,
        year: value,
      };
      apiRequest("POST", "daten", payload, headers, dataCbAdmin, errorCb);
    } else {
      const headers = {
        Authorization: "Bearer " + accessToken,
      };

      const payload = {
        mandant: client,
        program: admin ? "PMAST1" : "PMAST0",
        statement: "STATISTIK_HOLEN",
        type: type,
        year: value,
      };
      apiRequest("POST", "daten", payload, headers, dataCb);
    }

    setYear(value);
  };

  const apiDataRequest = (payload, headers) => {
    return axios.post(API_BASE_URL + "daten", payload, {
      withCredentials: true,
      headers: headers,
    });
  };

  const handleTypeChange = (event) => {
    setType(event.target.value);
  };

  const handleUrlaubskontoChange = (event) => {
    setUrlaubskonto(event.target.value);
  };

  const handleGleitzeitkontoChange = (event) => {
    setGleitzeitkonto(event.target.value);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const open = (key, name) => {
    //setShowModal(true);
    //downloadFile(key);
    setZJ(key);
    setZJName(name);
  };
  function InExcel() {
    setShowModal(true);
    const payload = {
      mandant: client,
      program: admin ? "PMAST1" : "PMAST0",
      statement: "EXCEL",
      type: type,
      year: year,
      urlaubskonto: urlaubskonten.findIndex((e) => e.key === urlaubskonto) + 1,
      gleitzeitkonto: gleitzeitkonten.findIndex((e) => e.key === gleitzeitkonto) + 1,
      data: data,
      anzahl: data.length,
      urlaubskonten: urlaubskonten,
      gleitzeitkonten: gleitzeitkonten,
      abrk: admin && laks[abrk]?.name,
      kst: admin && kkst[kst]?.name,
      gruppe: !admin && gruppen && gruppen[gruppen.findIndex((e) => e.key === gruppe)] ? gruppen[gruppen.findIndex((e) => e.key === gruppe)].bez : "",
      untergeben:
        !admin && magruppen && magruppen[magruppen.findIndex((e) => e.key === untergeben)]
          ? magruppen[magruppen.findIndex((e) => e.key === untergeben)].bez
          : "",
      abrkkey: admin && laks[abrk]?.key,
      kstkey: admin && kkst[kst]?.key,
      gruppekey: !admin && gruppe,
      untergebenkey: !admin && untergeben,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        var fileName = "Mitarbeiterstatistik_" + year + ".xlsx";
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }

  function Zeitjournal() {
    return (
      <ResponsiveDialog
        title={t("Zeitjournal(e) von ") + ZJName}
        open={ZJ !== ""}
        setOpen={(o) => {
          setZJ("");
          setZJName("");
        }}
        actionButton={
          <Button
            color="primary"
            onClick={() => {
              setZJ("");
              setZJName("");
            }}
          >
            {t("Zurück")}
          </Button>
        }
      >
        <DialogContent>
          <TimeAccount client={client} accessToken={accessToken} user={ZJ} />
        </DialogContent>
      </ResponsiveDialog>
    );
  }
  function AnzeigeUrlaub() {
    return (
      <ResponsiveDialog
        title={t("Urlaubsstatistik von ") + currentName}
        maxWidth="sm"
        open={openUrlaub === 1}
        setOpen={(o) => setOpenUrlaub(0)}
        actionButton={
          <Button color="primary" onClick={() => Abbrechen()}>
            {t("Zurück")}
          </Button>
        }
      >
        <DialogContent>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>{t("Personalnr")}</TableCell>
                  <TableCell align="right">{currentPnr}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Rest Vorjahr")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.rvorj}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Jahresurlaub")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.jurl}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Verbrauch gesamt")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.gen}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("> Davon Genommen")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.genc}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("> Davon Korrekturen")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.korr}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("> Davon Auszahlungen")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.ausz}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Verfallen")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.verf}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Endstand")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.summe}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </ResponsiveDialog>
    );
  }
  function AnzeigeKrank() {
    return (
      <ResponsiveDialog
        title={t("Krankheitsstatistik von ") + currentName}
        open={openKrank === 1}
        maxWidth="sm"
        setOpen={(o) => setOpenKrank(0)}
        actionButton={
          <Button color="primary" onClick={() => Abbrechen()}>
            {t("Zurück")}
          </Button>
        }
      >
        <DialogContent>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>{t("Personalnr")}</TableCell>
                  <TableCell align="right">{currentPnr}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Januar")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[0].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Februar")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[1].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("März")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[2].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("April")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[3].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Mai")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[4].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Juni")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[5].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Juli")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[6].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("August")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[7].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("September")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[8].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Oktober")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[9].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("November")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[10].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Dezember")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.mon[11].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Gesamt")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.krank && currentObject.krank.summe}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </ResponsiveDialog>
    );
  }
  function AnzeigeGleitzeit() {
    return (
      <ResponsiveDialog
        title={t("Gleitzeitstatistik von ") + currentName}
        maxWidth="sm"
        open={openGleitzeit === 1}
        setOpen={(o) => setOpenGleitzeit(0)}
        actionButton={
          <Button color="primary" onClick={() => Abbrechen()}>
            {t("Zurück")}
          </Button>
        }
      >
        <DialogContent>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>{t("Personalnr")}</TableCell>
                  <TableCell align="right">{currentPnr}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Übertrag")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.ueb}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Januar")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[0].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Februar")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[1].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("März")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[2].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("April")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[3].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Mai")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[4].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Juni")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[5].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Juli")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[6].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("August")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[7].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("September")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[8].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Oktober")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[9].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("November")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[10].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Dezember")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.mon && currentObject.mon[11].val}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("Gesamt")}</TableCell>
                  <TableCell align="right">{currentObject && currentObject.summe}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </ResponsiveDialog>
    );
  }
  function Abbrechen() {
    setOpenUrlaub(0);
    setOpenKrank(0);
    setOpenGleitzeit(0);
    setCurrentPnr("");
    setCurrentName("");
    setCurrentObject();
  }

  const renderHeader = () => {
    if (type === "URLAUB") {
      return (
        <TableRow>
          <TableCell scope="col">{t("Name")}</TableCell>
          <Hidden lgDown>
            <TableCell>{t("Personalnr")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Rest Vorjahr")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Jahresurlaub")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Verbrauch Gesamt")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("> Davon Genommen")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("> Davon Korrekturen")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("> Davon Auszahlungen")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Verfallen")}</TableCell>
          </Hidden>
          <TableCell align="right">{t("Endstand")}</TableCell>
        </TableRow>
      );
    } else if (type === "KRANK") {
      return (
        <TableRow>
          <TableCell>{t("Name")}</TableCell>
          <Hidden lgDown>
            <TableCell>{t("Personalnr")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Jan.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Feb.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("März")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Apr.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Mai")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Juni")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Juli")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Aug.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Sep.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Okt.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Nov.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Dez.")}</TableCell>
          </Hidden>
          <TableCell align="right">{t("Gesamt")}</TableCell>
        </TableRow>
      );
    } else if (type === "GLEITZEIT") {
      return (
        <TableRow>
          <TableCell>{t("Name")}</TableCell>
          <Hidden lgDown>
            <TableCell>{t("Personalnr")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Übertrag")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Jan.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Feb.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("März")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Apr.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Mai")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Juni")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Juli")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Aug.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Sep.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Okt.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Nov.")}</TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>{t("Dez.")}</TableCell>
          </Hidden>
          <TableCell align="right">{t("Gesamt")}</TableCell>
        </TableRow>
      );
    } else if (type === "ZEITJOURNALE") {
      return (
        <TableRow>
          <TableCell scope="col">{t("Lade Zeitkonten von")}</TableCell>
        </TableRow>
      );
    } else {
      return (
        <TableRow>
          <TableCell scope="col">{t("Name")}</TableCell>
        </TableRow>
      );
    }
  };

  const displayResult = useMemo(
    () =>
      data
        .filter((item, index) => {
          if (item.own === "J") return true;
          if (untergeben && untergeben !== "A" && item?.untergeben?.includes(untergeben) === false && item?.mitglied?.includes(untergeben) === false) {
            return false;
          }
          if (gruppe && gruppe !== "A" && item.gruppe.includes(gruppe) === false && item.mgruppe.includes(gruppe) === false) {
            return false;
          }
          if (untergeben && untergeben === "M" && item.vgruppe.includes(gruppe) === true) {
            return false;
          }
          if (kst === 0 && abrk === 0) return true;
          if (kst !== 0) {
            if (item.kst.substr(0, 4) !== kkst[kst].key) return false;
          }
          if (abrk !== 0) {
            if (item.abrk.substr(0, 2) !== laks[abrk].key) return false;
          }
          return true;
        })
        .map((dataObject, count) => {
          const name = dataObject.name;
          if (name && name.toLowerCase().includes(filter.toLowerCase())) {
            if (type === "URLAUB") {
              const kontoObject = dataObject?.urlaub?.konten.find((e) => e.key === urlaubskonto);
              return (
                <Fragment>
                  <Hidden lgUp>
                    <TableRow
                      key={dataObject.pnr}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOpenUrlaub(1);
                        setCurrentObject(kontoObject);
                        setCurrentPnr(dataObject.pnr);
                        setCurrentName(dataObject.name);
                      }}
                    >
                      <TableCell scope="row">{name}</TableCell>
                      <TableCell align="right">{kontoObject?.summe}</TableCell>
                    </TableRow>
                  </Hidden>
                  <Hidden lgDown>
                    <TableRow key={dataObject.pnr}>
                      <TableCell scope="row">{name}</TableCell>
                      <TableCell>{dataObject.pnr}</TableCell>
                      <TableCell>{kontoObject?.rvorj}</TableCell>
                      <TableCell>{kontoObject?.jurl}</TableCell>
                      <TableCell>{kontoObject?.gen}</TableCell>
                      <TableCell>{kontoObject?.genc}</TableCell>
                      <TableCell>{kontoObject?.korr}</TableCell>
                      <TableCell>{kontoObject?.ausz}</TableCell>
                      <TableCell>{kontoObject?.verf}</TableCell>
                      <TableCell align="right">{kontoObject?.summe}</TableCell>
                    </TableRow>
                  </Hidden>
                </Fragment>
              );
            } else if (type === "KRANK") {
              return (
                <Fragment>
                  <Hidden lgUp>
                    <TableRow
                      key={dataObject.pnr}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOpenKrank(1);
                        setCurrentObject(dataObject);
                        setCurrentPnr(dataObject.pnr);
                        setCurrentName(dataObject.name);
                      }}
                    >
                      <TableCell scope="row">{name}</TableCell>
                      <TableCell align="right">{dataObject.krank.summe}</TableCell>
                    </TableRow>
                  </Hidden>
                  <Hidden lgDown>
                    <TableRow key={dataObject.pnr}>
                      <TableCell scope="row">{name}</TableCell>
                      <TableCell>{dataObject.pnr}</TableCell>
                      <TableCell>{dataObject.krank.mon[0].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[1].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[2].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[3].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[4].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[5].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[6].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[7].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[8].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[9].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[10].val}</TableCell>
                      <TableCell>{dataObject.krank.mon[11].val}</TableCell>
                      <TableCell align="right">{dataObject.krank.summe}</TableCell>
                    </TableRow>
                  </Hidden>
                </Fragment>
              );
            } else if (type === "GLEITZEIT") {
              const kontoObject = dataObject?.glzs?.konten.find((e) => e.key === gleitzeitkonto);
              return (
                <Fragment>
                  <Hidden lgUp>
                    <TableRow
                      key={dataObject.pnr}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOpenGleitzeit(1);
                        setCurrentObject(kontoObject);
                        setCurrentPnr(dataObject.pnr);
                        setCurrentName(dataObject.name);
                      }}
                    >
                      <TableCell>{name}</TableCell>
                      <TableCell align="right">{kontoObject.summe}</TableCell>
                    </TableRow>
                  </Hidden>
                  <Hidden lgDown>
                    <TableRow key={dataObject.pnr}>
                      <TableCell>{name}</TableCell>
                      <TableCell>{dataObject.pnr}</TableCell>
                      <TableCell>{kontoObject.ueb}</TableCell>
                      <TableCell>{kontoObject.mon[0].val}</TableCell>
                      <TableCell>{kontoObject.mon[1].val}</TableCell>
                      <TableCell>{kontoObject.mon[2].val}</TableCell>
                      <TableCell>{kontoObject.mon[3].val}</TableCell>
                      <TableCell>{kontoObject.mon[4].val}</TableCell>
                      <TableCell>{kontoObject.mon[5].val}</TableCell>
                      <TableCell>{kontoObject.mon[6].val}</TableCell>
                      <TableCell>{kontoObject.mon[7].val}</TableCell>
                      <TableCell>{kontoObject.mon[8].val}</TableCell>
                      <TableCell>{kontoObject.mon[9].val}</TableCell>
                      <TableCell>{kontoObject.mon[10].val}</TableCell>
                      <TableCell>{kontoObject.mon[11].val}</TableCell>
                      <TableCell align="right">{kontoObject.summe}</TableCell>
                    </TableRow>
                  </Hidden>
                </Fragment>
              );
            } else if (type === "ZEITJOURNALE") {
              if (dataObject.zeaktiv === "1") {
                return (
                  <TableRow style={{ cursor: "pointer" }} key={dataObject.key} onClick={() => open(dataObject.key, dataObject.name)}>
                    <TableCell>{name}</TableCell>
                  </TableRow>
                );
              }
            } else {
              return (
                <Hidden xsUp>
                  <TableRow key={dataObject.urlaub.pnr}>
                    <TableCell>{name}</TableCell>
                    <Hidden>
                      <TableCell>{dataObject.pnr}</TableCell>
                    </Hidden>
                  </TableRow>
                </Hidden>
              );
            }
          } else {
            return (
              <Hidden xsUp>
                <TableRow key={dataObject.urlaub && dataObject.urlaub.pnr}>
                  <TableCell scope="row">{name}</TableCell>
                  <Hidden lgDown>
                    <TableCell>{dataObject.pnr}</TableCell>
                  </Hidden>
                </TableRow>
              </Hidden>
            );
          }
        }),
    [data, untergeben, gruppe, year, type, urlaubskonto, filter, gleitzeitkonto],
  );

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <Page>
      {Zeitjournal()}
      {AnzeigeUrlaub()}
      {AnzeigeKrank()}
      {AnzeigeGleitzeit()}
      <Layout fullWidth>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8}>
            <Box pt={2} pl={2} pr={2}>
              <Card>
                <Box p={1}>
                  <Grid container spacing={2}>
                    {filteraktiv === "J" && (
                      <Grid item xs={12}>
                        <Modulgruppenfilter
                          gruppen={gruppen}
                          selectedGruppe={gruppe}
                          onMitarbeiterChange={setUntergeben}
                          onGruppeChange={setGruppe}
                          kz={"full"}
                          nobox={true}
                          notitle={true}
                          mitarbeiter={magruppen}
                          selectedMitarbeiter={untergeben}
                        />
                      </Grid>
                    )}
                    {admin && (
                      <Fragment>
                        <Grid item xs={6}>
                          <TextField
                            id="Abrechnungskreis"
                            label={t("Abrechnungskreis")}
                            select
                            fullWidth
                            value={abrk}
                            onChange={(e) => {
                              setAbrk(e.target.value);
                            }}
                            variant="outlined"
                          >
                            {laks &&
                              laks.map((item, index) => (
                                <MenuItem key={index} value={index}>
                                  {item.name}
                                </MenuItem>
                              ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            id="Kostenstelle"
                            label={t("Kostenstelle")}
                            select
                            fullWidth
                            value={kst}
                            onChange={(e) => {
                              setKst(e.target.value);
                            }}
                            variant="outlined"
                          >
                            {kkst &&
                              kkst.map((item, index) => (
                                <MenuItem key={index} value={index}>
                                  {item.name}
                                </MenuItem>
                              ))}
                          </TextField>
                        </Grid>
                      </Fragment>
                    )}

                    <Grid item xs={6}>
                      <TextField id="type" label={t("Statistikauswahl")} select value={type} onChange={handleTypeChange} variant="outlined" fullWidth>
                        {statistics.map((item) => {
                          return (
                            <MenuItem key={item.key} value={item.key}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    {type !== "ZEITJOURNALE" && (
                      <Grid item xs={6}>
                        <TextField id="year" label={t("Jahr")} select value={year} onChange={handleYearChange} variant="outlined" fullWidth>
                          {[-3, -2, -1, 0, 1].map((yearDiff) => {
                            var yearToChoose = new Date().getFullYear() + yearDiff;
                            return (
                              <MenuItem key={yearToChoose.toString()} value={yearToChoose.toString()}>
                                {yearToChoose.toString()}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </Grid>
                    )}
                    {type === "URLAUB" && urlaubskonten.length > 1 && (
                      <Grid item xs={12} sm={6}>
                        <TextField id="urlaub" label={t("Konto")} select value={urlaubskonto} onChange={handleUrlaubskontoChange} variant="outlined" fullWidth>
                          {urlaubskonten.map((konto) => {
                            return (
                              <MenuItem key={konto.key} value={konto.key}>
                                {konto.name}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </Grid>
                    )}
                    {type === "GLEITZEIT" && gleitzeitkonten.length > 1 && (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="gleitzeit"
                          label={t("Konto")}
                          select
                          value={gleitzeitkonto}
                          onChange={handleGleitzeitkontoChange}
                          variant="outlined"
                          fullWidth
                        >
                          {gleitzeitkonten.map((konto) => {
                            return (
                              <MenuItem key={konto.key} value={konto.key}>
                                {konto.name}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Layout>
      <Layout>
        <Paper>
          <Toolbar>
            <form style={{ flexGrow: 1 }}>
              <Box p={1}>
                <SearchTextField
                  fullWidth
                  label={t("Suche")}
                  id="filter"
                  variant="outlined"
                  value={filter}
                  inputProps={{
                    autoCapitalize: "off",
                    autoCorrect: "off",
                    spellCheck: "false",
                    autoComplete: "off",
                  }}
                  onChange={handleFilterChange}
                />
              </Box>
            </form>
          </Toolbar>
          <TableContainer sx={{ maxHeight: window.innerHeight - 400 }}>
            <Table stickyHeader>
              <TableHead>{renderHeader()}</TableHead>
              <TableBody>{displayResult}</TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Layout>
      {showModal && <FullPageSpinner />}
      {(type === "URLAUB" || type === "KRANK" || type === "GLEITZEIT") && (
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box p={1}>
              <Button variant="contained" color="primary" fullWidth startIcon={<GridOnIcon />} onClick={() => InExcel()}>
                {t("In Excel")}
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
    </Page>
  );
}
export default EmployeeStatistics;
